import { render, staticRenderFns } from "./ModuleButtonRegister.vue?vue&type=template&id=37ac7d97&"
import script from "./ModuleButtonRegister.vue?vue&type=script&lang=tsx&"
export * from "./ModuleButtonRegister.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports